


































import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({})
export default class ProductStockPicker extends Vue {
  //@Prop() value!: any;
  @Prop() product_id!: number;

  items: Array<any> = [];
  resData: any= [];
  isYear = false;

  @Watch('product_id')
  onProductIdChange() {
    if (this.product_id)
      this.load();
  }
  updateValue (value:any) {
    this.$emit('product-stock-id', value.product_option_id)
    this.$emit('input', value)
  }
  onIsYearChange() {
      this.$emit('isYear', this.isYear);
  }

  mounted() {
    this.load();
    this.isYear = false;
    this.$emit('isYear', this.isYear);
  }

  load() {
    if (this.product_id==1){
      this.isYear=true;
      this.$emit('isYear', this.isYear);
    }

    this.$http.get('/product/' + this.product_id).then(res => {
     // this.resData =res.data; // console.log("dataaaa",res.data);
      this.items = res.data.variant_options;
      console.log("product stock ->", this.items);
    })
  }

}
